var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$wait.is("fetching")
      ? _c(
          "div",
          { staticClass: "loading" },
          [_c("Spinner", { attrs: { height: 40, width: 40 } })],
          1
        )
      : _vm.items && _vm.items.length
      ? _c(
          "div",
          { staticClass: "sector-post-feed" },
          [
            _vm._l(_vm.items, function (item) {
              return _c("SectorPostCard", {
                key: `sector-post-${item.id}`,
                attrs: {
                  resource: item,
                  "load-comments": false,
                  "sector-id": _vm.sectorIds[0],
                },
                on: {
                  "model-updated": _vm.handlePostUpdated,
                  "comment-click": function ($event) {
                    return _vm.handleNavigationToPost(item.id)
                  },
                  deleted: _vm.handlePostDeleted,
                },
              })
            }),
            _vm._v(" "),
            _vm.items.length && !_vm.end
              ? _c(
                  "mugen-scroll",
                  {
                    attrs: {
                      "scroll-container": "main-content",
                      handler: _vm.loadMore,
                      "should-handle": !_vm.$wait.is("fetching_more"),
                      threshold: 0.75,
                    },
                  },
                  [
                    _c(
                      "div",
                      { staticClass: "loading" },
                      [_c("Spinner", { attrs: { height: 30, width: 30 } })],
                      1
                    ),
                  ]
                )
              : _vm._e(),
          ],
          2
        )
      : _vm.end && !_vm.items.length
      ? _c("div", { staticClass: "no-results" }, [
          _c("span", [
            _vm._v(
              "There are currently no posts — be the first to share your thoughts!"
            ),
          ]),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }